import * as React from "react";
const useSync = (channelName, callback) => {
  const broadcastChannelRef = React.useRef(null);
  const getChannel = React.useCallback(() => {
    if (!broadcastChannelRef.current) {
      broadcastChannelRef.current = new BroadcastChannel(channelName);
    }
    return broadcastChannelRef.current;
  }, [channelName]);
  const broadcastUpdate = () => {
    const channel = getChannel();
    channel.postMessage("update");
  };
  React.useEffect(() => {
    const channel = getChannel();
    if (callback) {
      channel.onmessage = () => {
        callback();
      };
    }
    return () => {
      channel.close();
      broadcastChannelRef.current = null;
    };
  }, [callback, getChannel]);
  return { broadcastUpdate, getChannel };
};
export {
  useSync
};
//# sourceMappingURL=use-sync.js.map
